import React from 'react';
import './footer.scss';
import StoreIcons from './StoreIcons';
import MenuFooterBottom from './MenuFooterBottom';
import MenuFooterLandingGenerica from './MenuFooterLandingGenerica';
import MenuFooterMain from './MenuFooterMain';
import FooterTopBar from './FooterTopBar';

const Footer = ({ settings }) => {
  return (
    <footer
      className={`footer module-top-gap footer--${settings.pageType}`}
      data-module-code='C-04'
      data-module-name='footer'
    >
      <div className='wrapper'>
        {settings.pageType === 'business' && (
          <>
            <FooterTopBar disableLinkLogo={settings.disableLinkLogo} />
            <MenuFooterMain langCode={settings.langCode} />
            <StoreIcons langCode={settings.langCode} />
            <MenuFooterBottom
              langCode={settings.langCode}
              from={settings.pageType}
            />
          </>
        )}
        {settings.pageType === 'landing' && (
          <MenuFooterLandingGenerica langCode={settings.langCode} />
        )}
      </div>
    </footer>
  );
};

export default Footer;
